import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Sheet, Button } from '@sm/wds-react';
import { IconMenu, IconX } from '@wds/icons';

import useMobileDrawerStyles from './useMobileDrawerTriggerStyles';

export const MobileDrawer = ({ menuColor, children }) => {
  const [drawerOpen, setOpen] = useState(false);
  const toggleDrawer = () => setOpen(!drawerOpen);

  const { MobileTrigger } = useMobileDrawerStyles();

  const buttonClass = `${MobileTrigger} sm-mobile-menu__cta sm-mobile-menu--${menuColor}`;

  return (
    <>
      <Button
        variant="text"
        size="sm"
        className={buttonClass}
        onClick={toggleDrawer}
        data-testid='Mobile-Trigger'
      >
        {drawerOpen ? <IconX /> : <IconMenu />}
      </Button>
      <Sheet
        show={drawerOpen}
        onClose={toggleDrawer}
        placement="left"
        offsetTop={50}
      >
        {children}
      </Sheet>
    </>
  );
};

MobileDrawer.propTypes = {
  menuColor: PropTypes.oneOf(['alt', 'secondary']),
  children: PropTypes.node.isRequired,
};

MobileDrawer.defaultProps = {
  menuColor: 'alt',
};

export default MobileDrawer;
